<template>
  <div class="colorbar-container">
    <div class="colorbar">
      <b-img
        :src="selectedBaseMapScheme"
        alt="standard-bathymetry-colorbar"
        class="colorbar-image"
      ></b-img>
    </div>
    <div
      v-for="layer in bathymetryInView"
      :key="`${layer.name}-colorbar-container`"
      class="colorbar"
    >
      <b-img
        :src="layer.colorbar"
        :alt="`${layer.name}-colorbar`"
        class="colorbar-image"
      ></b-img>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { mapState } from 'vuex';
import standardColorbar from '../../assets/img/map-colorbars/standard-basemap-colorbar.png';
import accessibleColorbar from '../../assets/img/map-colorbars/accessible-basemap-colorbar.png';

export default {
  name: 'Colorbar',
  data() {
    return {
      baseMapScheme: {
        standard: standardColorbar,
        accessible: accessibleColorbar,
      },
    };
  },
  computed: {
    ...mapState({
      map: (state) => state.webmap,
      currentSite: (state) => state.currentSite,
      selectedArea: (state) => state.selectedArea,
      bathymetryInView: (state) => state.bathymetryInView,
      currentBaseMapScheme: (state) => state.currentBaseMapScheme,
    }),
    selectedBaseMapScheme() {
      return this.baseMapScheme[this.currentBaseMapScheme];
    },
  },
};
</script>

<style>
.colorbar-container {
  width: 240px;
  margin-bottom: 10px;
  display: flex;
  align-content: center;
}

.colorbar-image {
  height: 200px;
}

.colorbar {
  margin-right: 10px;
  padding: 2px;
  background-color: rgba(31, 31, 31, 0.8);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.74) !important;
}

.axial {
  color: #fff !important;
}
</style>
